import { liteClient as algoliasearch } from 'algoliasearch/lite';

// CRA n'injecte dans le bundle navigateur que les variables préfixées
// REACT_APP_ : toute autre clé (ex. process.env.ALGOLIA_APP_ID) reste un
// `process.env.X` littéral non résolu -> ReferenceError "process is not
// defined" à l'exécution (process n'existe pas dans le navigateur).
export const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID;
export const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY;
export const ALGOLIA_INDEX_PREFIX = process.env.REACT_APP_ALGOLIA_INDEX_PREFIX || '';

export const ALGOLIA_INDEX_FICHES = `${ALGOLIA_INDEX_PREFIX}fiches`;

export const algoliaSearchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY);
